export default "__VITE_ASSET__BsSB8vb___"